// Home.js
import React from 'react'
import Navbar from '../component/Navbar';
import Footer from '../component/Footer';
import '../style/style.css'
import { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import {useNavigate} from "react-router-dom";
import { HashLink as Link } from 'react-router-hash-link';


function ShrinkCard({ children, className }) {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start start", "end start"]
  });
  const scale = useTransform(scrollYProgress, [0, 1], [1, 1]);

  return (
    <motion.div ref={ref} className={`card-sticky ${className || ''}`} style={{ scale, transformOrigin: 'top center' }}>
        {children}
    </motion.div>
  );
}

function Home() {
    const link = require('../img/href.png');
    const navigate = useNavigate();

    return (
        <div>
            <Navbar />
            <ShrinkCard className='FirstDiv'>
                <div className='SmTxt'>
                    <p className='SmHeading'>DIGITAL AGENCY  ·  EST. 2026</p>
                    <a className='SmHeading Scroll'>SCROLL ↓</a>
                </div>
                <div className='Wrapper'>
                    <p className='Motto'>WE SHAPE <span>DIGITAL</span> FUTURES</p>
                    <p className='WWD'> Web design, 3D modelling,<br></br>
                        and AI-generated content<br></br>
                        for brands that lead.
                    </p>
                </div>
            </ShrinkCard>
            <ShrinkCard className='ServicesBlock'>
                <p className='SmHeading'>SERVICES</p>
                <p className='BigHeading'>WHAT WE DO</p>
                <div className='ServiceBlockPart'>
                    <p className='Numeric'>
                        (01)
                    </p>
                    <Link to='/services#WebDesign' className='ServicesWrapper'>
                        <p className='Servicename'>
                            WEB DESIGN & DEVELOPMENT
                        </p>
                        <div className='ServiceElementWrapper'>
                            <div className='ServiceElement'>
                                <p>
                                    React<span className='MobileHidden'>/Next.js</span>
                                </p>
                            </div>
                            <div className='ServiceElement'>
                                <p>
                                    UI/UX
                                </p>
                            </div>
                            <div className='ServiceElement'>
                                <p>
                                    CMS
                                </p>
                            </div>
                            <div className='ServiceElement MobileHidden'>
                                <p>
                                    Perfomance
                                </p>
                            </div>
                        </div>
                    </Link>
                    <Link to='/services#WebDesign' className='HrefArrow'><img src = {link} className='HrefArrow'/></Link>
                </div>
                <div className='ServiceBlockPart'>
                    <p className='Numeric'>
                        (02)
                    </p>
                    <Link to='/services#AI' className='ServicesWrapper'>
                        <p className='Servicename'>
                            AI-GENERATED CONTENT
                        </p>
                        <div className='ServiceElementWrapper'>
                            <div className='ServiceElement'>
                                <p>
                                    Images
                                </p>
                            </div>
                            <div className='ServiceElement'>
                                <p>
                                    Video
                                </p>
                            </div>
                            <div className='ServiceElement MobileHidden'>
                                <p>
                                    Prompt Eng.
                                </p>
                            </div>
                            <div className='ServiceElement'>
                                <p>
                                    Scale
                                </p>
                            </div>
                        </div>
                    </Link>
                    <Link to='/services#AI' className='HrefArrow'><img src = {link} className='HrefArrow'/></Link>
                </div>
{/*                <div className='ServiceBlockPart'>
                    <p className='Numeric'>
                        (03)
                    </p>
                    <Link to='/services#BrandIdentity' className='ServicesWrapper'>
                        <p className='Servicename'>
                            BRAND IDENTITY
                        </p>
                        <div className='ServiceElementWrapper'>
                            <div className='ServiceElement'>
                                <p>
                                    Strategy
                                </p>
                            </div>
                            <div className='ServiceElement'>
                                <p>
                                    Logo
                                </p>
                            </div>
                            <div className='ServiceElement'>
                                <p>
                                    Typography
                                </p>
                            </div>
                            <div className='ServiceElement MobileHidden'>
                                <p>
                                    Systems
                                </p>
                            </div>
                        </div>
                    </Link>
                    <Link to ='/services#AI' className='HrefArrow'><img src = {link} className='HrefArrow'/></Link>
                </div> */}
            </ShrinkCard>
            <ShrinkCard className='Works'>
                <p className='SmHeading'>SELECTED WORKS</p>
                <Link to='/work' className='BigHeading'>RECENT PROJECTS</Link>
                <div className='WorksWrapper'>
                    <Link to='/work#Web' className='BlockWrapper BW1'>
                        <div className='BlockHeadingWrapper'>
                            <p className='WorkType'>
                                WEB + 3D
                            </p>
                            <p className='Year'>
                                2025
                            </p>
                        </div>
                    </Link>
                    <Link to='/work#AI' className='BlockWrapper BW2'>
                        <div className='BlockHeadingWrapper'>
                            <p className='WorkType'>
                                AI CONTENT
                            </p>
                            <p className='Year'>
                                2025
                            </p>
                        </div>
                    </Link>
                </div>
                {/*<div className='DownWork MobileHidden'>
                    <p className='WorkType'>
                        WEB DESIGN
                    </p>
                    <p className='WorkName'>
                        Forma Studio
                    </p>
                    <a className='StudyHref'>
                        View Case Study <img src={link}/>
                    </a>
                </div>*/}
                {/*<a className='AllWork'>
                    <p className='AllWorkTxt'>
                        VIEW ALL WORK<span className='Hidden'> →</span>
                    </p>
                    <div className='line MobileHidden'></div>
                    <img src={link} className='Arrow MobileHidden'/>
                </a>*/}
            </ShrinkCard>
            <ShrinkCard className='Info'>
                <p className='SmHeading'>WHO WE ARE</p>
                <div className='InfoWrapper'>
                    <p className='BigTxt'>
                        A STUDIO<br/>
                        OBSESSED WITH <span className='MobileHidden'><br/></span>
                        THE FUTURE.
                    </p>
                    <div className='DataWrapper'>
                        <p className='Letters LongText'>
                            TAK STUDIO blends technology and artistry. We help brands lead their category through standout web experiences, immersive 3D, and AI-powered visual content.
                        </p>
                        <div className='Stats'>
                            <div className='StatsUpper'>
                                <div className='ProjectsWrapper'>
                                    <p className='Numbers'>120 +</p>
                                    <p className='Letters'>Projects</p>
                                </div>
                            </div>
                            <div className='StatsUnder'>
                                <div className='SatisfactionWrapper'>
                                    <p className='Numbers'>98%</p>
                                    <p className='Letters'>Satisfaction</p>
                                </div>
                                <div className='ExpWrapper'>
                                    <p className='Numbers'>3D + AI</p>
                                    <p className='Letters'>Expertise</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ShrinkCard>
            <ShrinkCard className='Contact'>
                <button id='StartAProjectBtn' onClick={() => navigate("/contact")}>
                    START A PROJECT
                </button>
                <p className='BigWhiteTxt'>LET'S BUILD<br/> SOMETHING GREAT.</p>
                <p className='Email'>hello@tak-studio.com</p>
                <button className='ContactBtn' onClick={() => navigate("/contact")}>Let's talk</button>
            </ShrinkCard>
            <div className='HomeFooter'>
                <Footer/>
            </div>
        </div>
    )
}

export default Home
